import {queryStringBuilder, ROUTE_LINE} from "../config/paths/apiPaths";
import mapMarkers from "../config/enum/mapMarkers";
import convert1980 from "../utils/hk1980-wgs";

export default {
  namespaced: true,

  state: {
    markers: [],
    mapCenter: {},
    mapBound: [],
    mapLines: [],
  },

  mutations: {
    setMapCenter(state, location) {
      state.mapCenter = location;
    },
    setMarkers(state, markers) {
      state.markers = markers;
      state.mapBound = markers.map(x => x.position);

    },
    setMapLine(state, lines) {
      state.mapLines = lines;

      console.log(state.mapLines);
    },
    openInfoWindow(state, marker) {
      const oldMarkers = state.markers;

      state.markers = oldMarkers.map(x => {
        if (x === marker) {
          return {
            ...x,
            infoWindowOpened: !x.infoWindowOpened,
          };
        }

        return x;
      });
    },
    openOnlyInfoWindow(state, marker) {
      const oldMarkers = state.markers;

      state.markers = oldMarkers.map(x => {
        if (
          x.routeid === marker.routeid &&
          x.routedir === marker.routedir &&
          x.stopseq === marker.stopseq
        ) {
          return {
            ...x,
            infoWindowOpened: true,
          };
        }

        return {
          ...x,
          infoWindowOpened: false,
        };
      });
    },
    updateBound(state, markers) {
      state.mapBound = markers.map(x => x.position);
    },
    cleanMarkers(state) {
      state.markers = [];
    },
    cleanRouteLine(state) {
      state.mapLines = [];
    },
  },

  actions: {
    async getRouteLine({commit}, stopDetails) {
      const response = await fetch(`${ROUTE_LINE}?${queryStringBuilder(stopDetails)}`);
      const json = await response.json();
      const line = eval(json.data.line);

      commit('setMapLine', [
        {
          line: line.flat().map(x => {
            const [lat, lng] = convert1980(x[1], x[0]);

            return {lat, lng};
          }),
          color: mapMarkers.color[stopDetails.routedir - 1],
        },
      ]);

    },
  },

  getters: {
    getMarkersLatLngList(state) {
      return state.markers
        .map(x => x.position)
    },
  }

}
